"use client";
import React, { useState, useEffect, useRef } from "react";
import "./ImageGallerySlider.scss";

interface ImageSliderProps {
  slides: any[];
  caption?: any[];
  autoPlay?: boolean;
  interval?: number;
  slidesToShow?: number;
  slideClass?: string;
  slideId?: string;
  btnText?: string;
  btnLink?: string;
  onClick?: () => void;
}

const ImageGallerySlider: React.FC<ImageSliderProps> = ({
  slides,
  caption,
  autoPlay = true,
  interval = 3000,
  slidesToShow = 3,
  slideClass,
  slideId,
  btnText,
  btnLink,
  onClick,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const sliderRef = useRef<HTMLDivElement>(null);

  // Next Slide
  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  // Previous Slide
  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? slides.length - 1 : prevIndex - 1
    );
  };

  // Autoplay Effect
  useEffect(() => {
    if (!autoPlay) return;
    const slideInterval = setInterval(nextSlide, interval);
    return () => clearInterval(slideInterval);
  }, [currentIndex, autoPlay, interval]);

  return (
    <div
      className={`mfg-slider-container${slideClass ? " " + slideClass : ""}`}
      id={slideId}
    >
      <button className="prev-button" onClick={prevSlide}>
        ❮
      </button>

      <div className="slider-wrapper" ref={sliderRef}>
        <div
          className="slider-track"
          style={{
            transform: `translateX(-${(currentIndex * 100) / slidesToShow}%)`,
          }}
        >
          {Object.values(slides).map((slide, index) => (
            <div
              key={index}
              className="slide"
              style={{ flex: `0 0 ${100 / slidesToShow}%` }}
            >
              <div className="slideInner">
              <img
                src={slide}
                alt={`Slide ${index}`}
                className="slider-image"
              />
              {caption && <div className="caption">{caption[index]}</div>}
              {(btnLink && (
                <a
                  href={btnLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn"
                >
                  {btnText}
                </a>
              )) ||
                (btnText && (
                  <button className="btn" onClick={onClick}>
                    {btnText}
                  </button>
                )) ||
                null}
              </div>
            </div>
          ))}
        </div>
      </div>

      <button className="next-button" onClick={nextSlide}>
        ❯
      </button>
    </div>
  );
};

export default ImageGallerySlider;
